const encodePath = (path) =>
  path
    .split('/')
    .map((segment) => encodeURIComponent(segment))
    .join('/');

export default function musicUrl(path) {
  return `/music/${encodePath(path)}`;
}
